// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'e-page-403',
  templateUrl: 'page-403.component.html',
  imports: [TranslateModule],
})
export class Page403Component {
}
